/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/UserOrganizations/UserOrganizations.Helper',[
    'jquery',
    'lodash',
    'global/all',
    './UserOrganizations.Selectors'
], function ($, _, Roc, Selectors) {
    'use strict';
    

    var UserOrganizationsHelper = {
    };

    Roc.Logger.debug('UserOrganizationsHelper.js Loaded:', UserOrganizationsHelper);

    return UserOrganizationsHelper;
});
